import { configureStore } from "@reduxjs/toolkit";

import ApproverSlice from "../function-components/Redux/Approver";
import MailSlice from "../function-components/Redux/Certificate";
import ClosureSlice from "../function-components/Redux/Closure";
import DipaSlice from "../function-components/Redux/Dipa";
import ModelSlice from "../function-components/Redux/Mailer";
import NudgeSlice from "../function-components/Redux/Nudge";
import RecognitionSlice from "../function-components/Redux/Recognition";
import ReminderSlice from "../function-components/Redux/Reminder";
import TeaserSlice from "../function-components/Redux/Teaser";
import TestimonialSlice from "../function-components/Redux/Testimonial";
import UserMaintanence from "../function-components/Redux/UserMaintanence";
import VivaSlice from "../function-components/Redux/Viva";
import TrackSlice from "../function-components/Redux/TrackSlice";
import DesignerSlice from "../function-components/Redux/Designer";
import CampaignDesignSlice from "../function-components/Redux/CampaignDesignSlice";


export default configureStore({
 reducer: {
  approver: ApproverSlice,
  model: ModelSlice,
  userRoles: UserMaintanence,
  teaser: TeaserSlice,
  reminder: ReminderSlice,
  nudge: NudgeSlice,
  recognition: RecognitionSlice,
  closure: ClosureSlice,
  mail: MailSlice,
  testimonial: TestimonialSlice,
  viva: VivaSlice,
  dipa: DipaSlice,
  track: TrackSlice,
  designer: DesignerSlice,
  campaignDesign: CampaignDesignSlice
 },
});
